import type { IExtendedObject } from "@/shared/common/types";
import { isEqual } from "@/shared/helpers";
import { useMemo } from "react";

export const useHasFormChanges = (defaultData: IExtendedObject, currentData: IExtendedObject) => {
  return useMemo(() => !isEqual(defaultData, currentData), [defaultData, currentData]);
};
